import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { contact, whatsappUrl } from '../data/site';

/** Discreet floating WhatsApp entry point. Appears after a small scroll. */
export function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-607" data-mp="1od9jxb4c0lcg">
      {visible ? <motion.a href={whatsappUrl} target="_blank" rel="noreferrer noopener" aria-label={`Chat on WhatsApp with ${contact.whatsappDisplay}`} title={`Chat on WhatsApp with ${contact.whatsappDisplay}`} className="group fixed bottom-5 right-4 z-[70] flex items-center gap-2 border border-line bg-surface2/90 px-4 py-3 text-ink backdrop-blur-md transition-colors hover:border-brand hover:text-brand sm:bottom-7 sm:right-7" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }} data-cursor="hover" data-id="element-608" data-mp="1oeb7ug6g52bl">
          <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-609" data-mp="mbl69rwgpw23" />
          <span className="label hidden sm:inline" data-id="element-610" data-mp="3lskng8m2w31w">Chat with us</span>
          <span className="sr-only sm:hidden" data-id="element-611" data-mp="3qqckti5hshdh">WhatsApp</span>
        </motion.a> : null}
    </AnimatePresence>;
}